import { Select } from '@mantine/core'
import SelectClasses from './styles.module.css'
import '../../styles/variables.css'

export default Select.extend({
    defaultProps: { radius: 'lg', size: 'lg' },
    classNames: SelectClasses,
})
